// api/Manager.ts
import { Model, Attr, HasOne } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import Office from './Office';

@Model()
class Manager extends ApplicationRecord {
  static jsonapiType = 'managers';

  // Attributes
  @Attr({ persist: false }) email!: string;
  @Attr({ persist: false }) civility!: string;
  @Attr({ persist: false }) firstName!: string;
  @Attr({ persist: false }) lastName!: string;
  @Attr({ persist: false }) landlinePhone!: string;

  // Relationships
  @HasOne('offices') office!: Office;
}

export default Manager;
